class collectionSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiper = new Swiper(".pfCollectionSwiper", {
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      on: {
        init: () => {
          this._animateActiveSlide();
        },
        slideChangeTransitionStart: () => {
          this._animateActiveSlide();
        }
      }
    });
  }
  disconnectedCallback() {}

  _animateActiveSlide() {
    const activeSlide = document.querySelector(".pfCollectionSwiper .swiper-slide-active");
    if (!activeSlide) return;

    const paragraph = activeSlide.querySelector(".paragraph p");
    if (!paragraph) return;
    const split = new SplitText(paragraph, {
      type: "lines",
      mask: "lines",
      linesClass: "pf-line"
    });
    gsap.from(split.lines, {
      y: 100,
      opacity: 0,
      stagger: 0.05,
      duration: 1,
      ease: "power2.out",
    });
  }
}

if (!customElements.get("pf-collection-slider")) {
  customElements.define("pf-collection-slider", collectionSlider);
}


// header search
class TextTyper extends HTMLElement {
  connectedCallback() {

    const box = this.querySelector('.fs-search-box');
    if (!box) return;

    const wordsAttr   = box.getAttribute('words') || "New Arrival, Baseline, Women Exclusive, Western Streetwear, Classic Wear";
    const typeSpeed   = parseInt(box.getAttribute('type-speed') || '90');
    const deleteSpeed = parseInt(box.getAttribute('delete-speed') || '55');
    const pause       = parseInt(box.getAttribute('pause') || '1500');

    const words = ['Search', ...wordsAttr.split(',').map(w => w.trim())];

    const typedEl  = document.createElement('span');
    const cursorEl = document.createElement('span');

    cursorEl.classList.add('fs-typer-cursor');

    box.appendChild(typedEl);
    box.appendChild(cursorEl);

    let wordIndex = 0;
    let charIndex = 0;
    let deleting  = false;

    const tick = () => {
      const word = words[wordIndex];

      if (!deleting) {
        typedEl.textContent = word.slice(0, charIndex++);

        if (charIndex > word.length) {
          deleting = true;
          setTimeout(tick, pause);
        } else {
          setTimeout(tick, typeSpeed);
        }

      } else {
        typedEl.textContent = word.slice(0, charIndex--);

        if (charIndex < 0) {
          deleting  = false;
          wordIndex = (wordIndex + 1) % words.length;
          charIndex = 0;
          setTimeout(tick, 320);
        } else {
          setTimeout(tick, deleteSpeed);
        }
      }
    };

    tick();
  }
}

customElements.define('text-typer', TextTyper);


// CUSTOM HEADER 
class MobileMenu extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector(".pf_mobile--overlay");
    this.openBtn = this.querySelector(".pf_nav-menu--openbtn");
    this.closeBtn = this.querySelector(".pf_nav-menu--closebtn");

    this.openBtn.addEventListener("click", () => this.openMenu());
    this.closeBtn.addEventListener("click", () => this.closeMenu());

    // Detect screen resize
    window.addEventListener("resize", () => this.handleResize());
  }

  openMenu() {
    this.overlay.classList.add("active");
    this.classList.add("menu-open");
    document.body.style.overflow = "hidden";
  }

  closeMenu() {
    this.overlay.classList.remove("active");
    this.classList.remove("menu-open");
    document.body.style.overflow = "";
  }

  handleResize() {
    if (window.innerWidth >= 992) {
      this.closeMenu();
    }
  }
}

if (!customElements.get("pf-header")) {
  customElements.define("pf-header", MobileMenu);
}

// PF Product Colleciton Slider

class PFProductImgSlider extends HTMLElement {
  connectedCallback() {

    const slider = this.querySelector('.pfProductImg');

    if (!slider) return;

    this.swiper = new Swiper(slider, {
      slidesPerView: "auto",
      centeredSlides: true,
      navigation: {
        nextEl: this.querySelector(".pf-slide-next--btn"),
        prevEl: this.querySelector(".pf-slide-prev--btn")
      }
    });

  }

  disconnectedCallback() {}
}

if (!customElements.get('pf-product-img')) {
  customElements.define('pf-product-img', PFProductImgSlider);
}



// Product Card Model Toggle
document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("modelViewToogle");

  function updateSlides() {
    const showModel = toggle.checked;

    document.querySelectorAll(".pfProductImg").forEach((slider) => {
      const swiperInstance = slider.swiper;

      if (!swiperInstance) return;

      if (showModel) {
        if (swiperInstance.slides.length > 1) {
          swiperInstance.slideTo(1, 0);
        }
      } else {
        swiperInstance.slideTo(0, 0);
      }
    });
  }

  toggle?.addEventListener("change", updateSlides);
});

// PF Size Guide
class PFProductInfo extends HTMLElement {

  connectedCallback() {
    this.initSizeGuide();
    this.initSizeToggle();
  }

  initSizeGuide(){

    const trigger = this.querySelector('.size_guide--text');
    const overlay = this.querySelector('[data-size-guide-overlay]');
    const closeBtn = overlay?.querySelector('.pf-size-guide-close');

    if(!trigger || !overlay) return;

    const open = () => {
      overlay.classList.add('active');
      document.body.classList.add('pf-size-guide-open');
    };

    const close = () => {
      overlay.classList.remove('active');
      document.body.classList.remove('pf-size-guide-open');
    };

    trigger.addEventListener('click', open);

    closeBtn?.addEventListener('click', close);

    overlay.addEventListener('click', (e)=>{
      if(e.target === e.currentTarget){
        close();
      }
    });

    document.addEventListener('keydown', (e)=>{
      if(e.key === 'Escape'){
        close();
      }
    });

  }


  initSizeToggle(){

    const toggle = this.querySelector('#sizesViewToogle');
    const cmLabel = this.querySelector('.pf-switcher-value.first');
    const inLabel = this.querySelector('.pf-switcher-value.second');
    const table = this.querySelector('.pf-size-guide-table');

    if(!toggle || !table) return;

    const rows = table.querySelectorAll('tbody tr');

    // store original CM values
    rows.forEach(row => {
      const cells = row.querySelectorAll('td');

      for(let i = 1; i < cells.length; i++){
        cells[i].dataset.cm = cells[i].textContent.trim();
      }
    });

    // default state
    cmLabel.classList.add('active');

    toggle.addEventListener('change', () => {
      const toInch = toggle.checked;

      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        for(let i = 1; i < cells.length; i++){
          const cmValue = parseFloat(cells[i].dataset.cm);
          if(toInch){
            // dummy inch conversion
            const inch = (cmValue / 2.54).toFixed(1);
            cells[i].textContent = inch;
          }else{
            // restore CM
            cells[i].textContent = cells[i].dataset.cm;
          }
        }
      });

      // switch active text
      cmLabel.classList.toggle('active', !toInch);
      inLabel.classList.toggle('active', toInch);
    });

  }

}

if (!customElements.get('pf-product-info')) {
  customElements.define('pf-product-info', PFProductInfo);
}


// megamenu
class FsMenuList extends HTMLElement {
  constructor() {
    super();
    this.images = [...this.closest(".main").querySelectorAll(".mega_menu--img img")];
  }

  connectedCallback() {
    this.addEventListener("mouseover", this.handleHover);
  }

  handleHover = (e) => {
    const menu = e.target.closest("li");
    if (!menu || !this.contains(menu)) return;

    const menus = [...this.querySelectorAll("li")];
    const index = menus.indexOf(menu);
    if (index === -1) return;

    menus.forEach(elm => elm.classList.remove("active"));
    menu.classList.add("active");

    this.images.forEach(elm => elm.classList.remove("active"));
    this.images[index].classList.add("active");
  };
}

if (!customElements.get("fs-menu-list")) {
  customElements.define("fs-menu-list", FsMenuList);
}


class PFLookBookAccordion extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.addEventListener(
      "click",
      (e) => {
        const header = e.target.closest(".accordion-header");
        if (!header || !this.contains(header)) return;

        const wrapper = header.closest(".accordion-wrapper");
        const body = header.nextElementSibling;
        const height = body.querySelector(".accordion-content").offsetHeight;
        const isOpen = body.classList.contains("open");

        wrapper.querySelectorAll(".accordion-body.open").forEach((item) => {
          item.classList.remove("open");
          item.style.height = 0 + "px";

          const prevHeader = item.previousElementSibling;
          prevHeader.classList.remove("active");
          prevHeader.style.background = "";
          prevHeader.style.backdropFilter = "blur(0)";
          prevHeader.style.webkitBackdropFilter = "blur(0)";
        });

        if (!isOpen) {
          body.classList.add("open");
          body.style.height = height + "px";
          header.classList.add("active");

          header.style.background = "rgba(255, 255, 255, 0.2)";
          header.style.backdropFilter = "blur(12px)";
          header.style.webkitBackdropFilter = "blur(12px)";
        } else {
          header.classList.remove("active");
          header.style.background = "";
          header.style.backdropFilter = "blur(0)";
          header.style.webkitBackdropFilter = "blur(0)";
        }
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if (!customElements.get("pf-lookbook-info")) {
  customElements.define("pf-lookbook-info", PFLookBookAccordion);
}

class PFLookBook extends HTMLElement {
  connectedCallback() {
    this.infoSlides = this.querySelectorAll(".lookbook-info-slide");

    this.thumbs = new Swiper(this.querySelector(".pfThumbSwiper"), {
      loop: true,
      slidesPerView: 3,
      watchSlidesProgress: true,
      spaceBetween: 6,
    });

    this.mainImg = new Swiper(this.querySelector(".pfLookbookSwipper"), {
      loop: true,
      navigation: {
        nextEl: this.querySelector(".pf_thumb-next"),
        prevEl: this.querySelector(".pf_thumb-prev"),
      },
      thumbs: {
        swiper: this.thumbs,
      },

      on: {
        slideChangeTransitionEnd: (swiper) => {
          const index = swiper.realIndex;

          // change product info
          this.changeInfo(index);

          // thumbnail active state
          this.thumbs.slides.forEach((slide) =>
            slide.classList.remove("swiper-slide-thumb-active"),
          );

          const nextSlide = this.thumbs.slides[index];
          if (nextSlide) {
            nextSlide.classList.add("swiper-slide-thumb-active");
            this.thumbs.slideToLoop(index);
          }
        },
      },
    });

    // when user swipe thumbnails
    this.thumbs.on("touchEnd", () => {
      this.mainImg.slideToLoop(this.thumbs.realIndex);
    });
  }

  changeInfo(index) {
    this.infoSlides.forEach((slide) => {
      slide.classList.remove("active");
    });

    const activeSlide = this.infoSlides[index];

    if (activeSlide) {
      requestAnimationFrame(() => {
        activeSlide.classList.add("active");
      });
    }
  }
}

if (!customElements.get("pf-lookbook")) {
  customElements.define("pf-lookbook", PFLookBook);
}

class PfDelivery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new Swiper(this, {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
}

if (!customElements.get("pf-delivery")) {
  customElements.define("pf-delivery", PfDelivery);
}


// media image show more

class MediaGalleryToggle extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }
  handleClick() {
    const sectionId = this.dataset.sectionId;
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    const label = this.querySelector(".label");
    if (!gallery) return;

    const isOpen = gallery.getAttribute("all-images") === "true";

    if (isOpen) {
      gallery.setAttribute("all-images", "false");
      if(label)
      label.textContent = "More Images"; // optional label
    } else {
      gallery.setAttribute("all-images", "true");
      if(label)
      label.textContent = "Show Less"; // optional label
    }
  }
}
if (!customElements.get("media-gallery-toggle")) {
  customElements.define("media-gallery-toggle", MediaGalleryToggle);
}


// pf-sticky add to cart

class PfStickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this._onTabClick = this._onTabClick.bind(this);
      this._onSizeClick = this._onSizeClick.bind(this);
      this._onVariantChange = this._onVariantChange.bind(this);
    }

    connectedCallback() {
      this.triggersWrapper = this.querySelector(".buttons_wrapper");
      this.contents = this.querySelectorAll(".contents_wrapper .content");
      this.sizeContents = this.querySelector(".content_sizes ul");
      this._initTabs();
      this._initSizes();
    }

    disconnectedCallback() {
      this.triggersWrapper?.removeEventListener("click", this._onTabClick);
      this.sizeContents?.removeEventListener("click", this._onSizeClick);
      document.removeEventListener("change", this._onVariantChange);
    }
    _initTabs() {
        if (!this.triggersWrapper) return;
        this.triggersWrapper.addEventListener("click", this._onTabClick);
    }

    _onTabClick(e) {

      const button = e.target.closest("button.button");
      if (!button) return;
      const index = button.dataset.tab;
      const currentActive = this.querySelector(".content.active");
      if (currentActive?.dataset.tab === index) return;
      this.contents.forEach(content => {
        if (content.dataset.tab === index) {
              content.classList.add("active");
              gsap.fromTo(
                  content, {
                      autoAlpha: 0,
                      y: 20
                  }, {
                      autoAlpha: 1,
                      y: 0,
                      duration: 0.4,
                      ease: "power2.out"
                  }
              );
        } else {
              content.classList.remove("active");
        }
      });
      this._initSizes();
    }

    _initSizes() {
        const variants = document.querySelectorAll(
            ".pf_size_container .variant-option__button-label input"
        );

        if (!variants.length || !this.sizeContents) return;

        this.sizeContents.removeEventListener("click", this._onSizeClick);
        document.removeEventListener("change", this._onVariantChange);

        this.sizeContents.innerHTML = "";

        variants.forEach(input => {
            const label = input.closest(".variant-option__button-label");
            const text = label?.textContent.trim();

            const li = document.createElement("li");
            li.textContent = text;
            li.dataset.value = input.value;

            if (input.checked) {
                li.classList.add("active");
            }

            this.sizeContents.appendChild(li);
        });

        this.sizeContents.addEventListener("click", this._onSizeClick);
        document.addEventListener("change", this._onVariantChange);

        gsap.fromTo(
            this.sizeContents.children, {
                autoAlpha: 0,
                y: 10
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.3,
                stagger: 0.05,
                ease: "power2.out"
            }
        );
    }

    _onSizeClick(e) {
        const li = e.target.closest("li");
        if (!li) return;

        const variants = document.querySelectorAll(
            ".pf_size_container .variant-option__button-label input"
        );

        variants.forEach(input => {
            if (input.value === li.dataset.value) {
                input.click();
            }
        });
    }

    _onVariantChange(e) {
        const input = e.target.closest(
            ".pf_size_container .variant-option__button-label input"
        );
        if (!input) return;

        const allLis = this.sizeContents.querySelectorAll("li");

        allLis.forEach(li => {
            li.classList.toggle("active", li.dataset.value === input.value);
        });

        const activeLi = this.sizeContents.querySelector("li.active");
        if (activeLi) {
            gsap.fromTo(
                activeLi, {
                    scale: 0.95
                }, {
                    scale: 1,
                    duration: 0.2,
                    ease: "power2.out"
                }
            );
        }
    }
}

if (!customElements.get("pf-sticky-add-to-cart")) {
    customElements.define("pf-sticky-add-to-cart", PfStickyAddToCart);
}


class PFSearchBtn extends HTMLElement {
  constructor() {
    super();
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", () => this._showModal());
  }

  _showModal() {
    const dialog = document.querySelector("dialog-component-jb dialog");
    if (!dialog) return;

    dialog.setAttribute("open", true);

    document.addEventListener("click", this._handleOutsideClick);

    const observer = new MutationObserver(() => {
      const panel = document.querySelector(".aa-Panel .aa-Panel--scrollable");
      if (!panel) return;

      panel.setAttribute("data-lenis-prevent", true);

      const cancelBtn = document.querySelector(".aa-DetachedCancelButton");
      const clearBtn = document.querySelector(".aa-ClearButton");

      cancelBtn?.addEventListener("click", () => this._closeDialog());
      clearBtn?.addEventListener("click", () => this._closeDialog());

      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  _handleOutsideClick(e) {
    const wrapper = document.querySelector("dialog-component-jb");
    const dialog = wrapper?.querySelector("dialog");
    if (!wrapper || !dialog) return;

    if (wrapper.contains(e.target) && !dialog.contains(e.target)) {
      this._closeDialog();
    }
  }

  _closeDialog() {
    const dialog = document.querySelector("dialog-component-jb dialog");
    if (!dialog) return;
    dialog.removeAttribute("open");
    document.removeEventListener("click", this._handleOutsideClick);
  }
}

if (!customElements.get("search-button")) {
  customElements.define("search-button", PFSearchBtn);
}